import React from "react";
import { Box, Text, UnstyledButton } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { StaffFace } from "../grid/StaffFace";
import type { ProviderOption } from "../sheets/ProviderOptionList";
import styles from "./MobileWeekProviderBar.module.css";

export interface MobileWeekProviderBarProps {
  /** The provider whose week is shown. */
  provider: ProviderOption;
  /** The provider is the signed-in user (adds "(You)"). */
  isSelf: boolean;
  /** Open the provider sheet. */
  onOpen: () => void;
}

/**
 * Week view: whose schedule the grid shows, as a chip (avatar, name, ▾) that
 * opens the provider sheet. The week grid shows one provider, so without
 * this an empty week reads as "no appointments" rather than "someone else's
 * week".
 */
export const MobileWeekProviderBar: React.FC<MobileWeekProviderBarProps> = ({
  provider,
  isSelf,
  onOpen,
}) => {
  const name = isSelf ? `${provider.name} (You)` : provider.name;
  return (
    <Box className={styles.bar} data-testid="mobile-week-provider-bar">
      <Text span className={styles.label}>
        Showing
      </Text>
      <UnstyledButton
        className={styles.chip}
        onClick={onOpen}
        aria-haspopup="dialog"
        aria-label={`Showing ${name}'s week. Change provider`}
        data-testid="mobile-week-provider-chip"
      >
        <Text span className={styles.avatar}>
          <StaffFace photo={provider.photo} initials={provider.initials} />
        </Text>
        <Text span className={styles.name}>
          {name}
        </Text>
        <IconChevronDown size={14} stroke={2} className={styles.chevron} />
      </UnstyledButton>
    </Box>
  );
};
